var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIlar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 17.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M581.661,246.581l3.3,3.619h8.373l-2.959-3.039L595.145,243v-10.8H582.5l-7.561,6.745v11.255h6.725Zm.035-8.38h6.69v5.961H581.7Z",
    transform: "translate(-531.145 -232.206)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M529.38,250.257H520.6V239.05l7.6-6.745h12.613v17.952h-6.76V246.1Zm4.669-11.957h-6.69v5.961h6.69Z",
    transform: "translate(-500.212 -232.263)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M501.142,232.228l-4.388,3.928v14.057h6.7V232.228Z",
    transform: "translate(-486.637 -232.219)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M473.265,232.32v5.455h3.706L473.265,241v9.268h6.76V232.32Z",
    transform: "translate(-473.265 -232.272)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIlar);
export default __webpack_public_path__ + "static/media/ilar.3d357810460807a2ea7546bc09efc41a.svg";
export { ForwardRef as ReactComponent };